import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from './auth.service';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private readonly authenticatedRoutes = [
    '/dashboard',
    '/projects',
    '/budget',
    '/burn',
  ];
  private forceHideSubject = new BehaviorSubject<boolean>(false);

  readonly visible$ = combineLatest([
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.url),
      startWith(this.router.url) // Start with current URL
    ),
    this.auth.user$,
    this.forceHideSubject,
  ]).pipe(
    map(([url, user, forceHide]) => {
      console.log('Header visibility check:', {
        url,
        hasUser: !!user,
        forceHide,
        isAuthenticatedRoute: this.authenticatedRoutes.some((route) =>
          url.startsWith(route)
        ),
      });

      if (forceHide) return false;
      const shouldShow = !!user;

      console.log('Header visibility decision:', { shouldShow });
      return shouldShow;
    })
  );

  constructor(private router: Router, private auth: AuthService) {
    console.log('HeaderService initialized, current URL:', this.router.url);
  }

  hide() {
    console.log('Header force hide requested');
    this.forceHideSubject.next(true);
  }

  show() {
    console.log('Header force show requested');
    this.forceHideSubject.next(false);
  }
}
